import { h, FunctionComponent } from 'preact';
import { ReachTabPanel } from 'components/Reach';
import { PanelContainer } from './Tabs.styles';

export interface TabPanelProps {
  className?: string;
  children?: any;
}

const TabPanel: FunctionComponent<TabPanelProps> = ({
  className,
  children,
}) => {
  return (
    <ReachTabPanel className={className}>
      <PanelContainer>{children}</PanelContainer>
    </ReachTabPanel>
  );
};

export default TabPanel;
